import { ClientConfig } from "agora-rtc-react";

// define config for rtc engine
export const config: ClientConfig = { 
    mode: "rtc", codec: "vp8",
};
